<template>
  <el-dialog
      :visible.sync="visible"
      title="付款记录"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%"
  >
    <vxe-toolbar ref="xToolbar" custom>
      <template v-slot:buttons>
        <el-form
            :inline="true"
            :model="queryForm"
            @keyup.enter.native="getDataList()"
            ref="queryForm"
            class="query-form"
        >
          <el-form-item prop="sellerName" label="付款对象：">
            <el-input v-model="queryForm.sellerName" size="mini" clearable type="text" style="width: 160px;"
                      placeholder="请输入付款对象"></el-input>
          </el-form-item>
          <el-form-item prop="payType" label="付款方式：">
            <el-input v-model="queryForm.payType" size="mini" clearable type="text" style="width: 160px;"
                      placeholder="请输入付款方式"></el-input>
          </el-form-item>
          <el-form-item prop="payNo" label="付款凭证号：">
            <el-input v-model="queryForm.payNo" size="mini" clearable type="text" style="width: 160px;"
                      placeholder="请输入付款凭证号"></el-input>
          </el-form-item>
          <el-form-item  label="付款时间：">
            <el-date-picker
                v-model="queryForm.beginDate"
                type="date"
                size="mini"
                style="width: 160px;"
                placeholder="选择查询起始日期">
            </el-date-picker>
            <el-date-picker
                v-model="queryForm.endDate"
                size="mini"
                type="date"
                style="width: 160px;margin-left: 10px;"
                placeholder="选择查询截止日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getDataList" size="mini">查询</el-button>
            <el-button @click="reset" size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </template>
    </vxe-toolbar>
    <vxe-table
        :id="tableConfig.id"
        :ref="tableConfig.tableName"
        show-overflow
        show-footer
        align="center"
        row-id="id"
        :max-height="500"
        :loading="tableData.loading"
        :data="tableData.dataList"
        :custom-config="{storage: true, checkMethod: checkColumnHandler}"
        :footer-method="tableFooter"
        @resizable-change="resizableChangeEvent">
      <vxe-column type="seq" title="行号" width="50"></vxe-column>
      <vxe-column field="receiptCode" title="发票号" min-width="120"></vxe-column>
      <vxe-column field="sellerName" title="付款对象" min-width="160" :formatter="companyNameFormatter"></vxe-column>
      <vxe-column field="payAmount" title="付款金额" min-width="90"></vxe-column>
      <vxe-column field="payType" title="付款方式" width="120"></vxe-column>
      <vxe-column field="payNo" title="付款凭证号" min-width="160"></vxe-column>
      <vxe-column field="payTime" title="付款时间" width="120"></vxe-column>
      <vxe-column field="remark" title="备注" min-width="160"></vxe-column>
      <vxe-column field="createDate" title="制单时间" width="160"></vxe-column>
      <vxe-column field="creatorName" title="制单人" min-width="100"></vxe-column>
    </vxe-table>
    <vxe-pager
        :loading="tableData.loading"
        :current-page="tableData.currentPage"
        :page-size="pagerConfig.pageSize"
        :total="tableData.total"
        :layouts="pagerConfig.layouts"
        @page-change="vxePageChanger">
    </vxe-pager>
    <template slot="footer">
      <el-button @click="cancel">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
          $t('confirm')
        }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import VxeTable from '@/mixins/vxe-table'

export default {
  name: 'pay-dialog',
  mixins: [VxeTable],
  data () {
    return {
      visible:false,
      tableConfig: {
        autoHeight: false,
        queryUrl: '/fund/pay/log/page',
        footerColumn: ['payAmount']
      },
      queryForm: {
        sellerName: '',
        receiptCode: '',
        payType:'',
        payNo:'',
        beginDate:'',
        endDate:''
      },
    }
  },
  methods: {
    init () {
      this.visible = true
      this.reload()
    },

    cancel () {
      this.visible = false
    },

  }
}
</script>

<style scoped>

</style>
